import BaseApiService from './BaseApiService'

export interface Starter {
  key: string
  name: string
  description: string
  category: string
}

class StartersApiService extends BaseApiService {
  list(): Promise<Starter[]> {
    return this.post('/v1/starters/list', {})
  }

  /** The starter rendered with its sample data. Not billed. */
  preview(key: string, signal?: AbortSignal): Promise<Blob> {
    return this.postBlob('/v1/starters/preview', { key }, signal)
  }

  /** Creates the template, a draft first version and a saved sample named "Sample". */
  create(key: string, name?: string, folderId?: string): Promise<{ templateId: string; templateVersionId: string }> {
    return this.post('/v1/starters/create', { key, name, folderId })
  }
}

export const startersApiService = new StartersApiService()
